<template>
    <TabWrapper @change="change">
        <v-row no-gutters>
            <v-col cols="12" md="3">
                <Toggle v-model="externalIsEnabled" @input="updateExternalIsEnabled"
                        label="Externer Zugang aktiv"></Toggle>
            </v-col>
            <v-col cols="12" md="4">
                <Input v-model="externalCode" label="Zugriffscode" :disabled="true"
                       hint="Wird beim Aktivieren generiert"></Input>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="8" lg="7">
                <Input v-model="externalIp" label="Netzwerk"
                       :error-messages="externalIpErrors"
                       @input="$v.externalIp.$touch()"
                       @blur="$v.externalIp.$touch()"></Input>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="8" lg="7">
                <Input v-model="externalMask" label="Netzwerkmaske"
                       :error-messages="externalMaskErrors"
                       @input="$v.externalMask.$touch()"
                       @blur="$v.externalMask.$touch()"></Input>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <Button class="mt-8" @click="submit" :color="ada.pink"
                        :loading="loading">
                    Speichern
                </Button>
            </v-col>
        </v-row>
    </TabWrapper>
</template>

<script>
import TabWrapper from "../../EmergencyStop/Tabs/TabWrapper";
import Toggle from "../../../components/buttons/Toggle";
import Input from "../../../components/Inputs/Input";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss";
import {requiredIf} from 'vuelidate/lib/validators'
import {validationMixin} from "vuelidate";
import Utils from "../../../scripts/Utils";

export default {
    name: "Configuration",
    components: {Button, Input, Toggle, TabWrapper},
    mixins: [validationMixin],
    validations: {
        externalMask: {
            required: requiredIf(function () {
                return this.externalIsEnabled === 1
            })
        },
        externalIp: {
            required: requiredIf(function () {
                return this.externalIsEnabled === 1
            }),
        }
    },
    data: () => {
        return {
            externalIsEnabled: 0,
            externalCode: null,
            externalIp: null,
            externalMask: 0,
            loading: false,
            ada
        }
    },
    mounted() {
        this.init();
        this.$emit('activeComponent', this);
    },
    computed: {
        selectedSite() {
            return this.$store.state.emergency.selectedSite;
        },
        siteDetails() {
            return this.$store.state.emergency.siteDetails;
        },
        updated() {
            return this.$store.state.emergency.updated;
        },
        externalIpErrors() {
            return Utils.handleError(this, 'externalIp', 'Netzwerk ist erforderlich.');
        },
        externalMaskErrors() {
            return Utils.handleError(this, 'externalMask', 'Netzwerkmaske ist erforderlich.');
        },
        validate() {
            return this.externalIpErrors.length === 0 &&
                this.externalMaskErrors.length === 0;
        },
        activeTab() {
            return this.$store.state.emergency.activeTab;
        }
    },
    methods: {
        init() {
            if (this.selectedSite) {
                this.$v.$reset();
                this.externalIsEnabled = this.selectedSite.ExternalIsEnabled;
                this.externalIp = this.selectedSite.ExternalIp;
                this.externalCode = this.selectedSite.ExternalCode;
                this.externalMask = this.selectedSite.ExternalMask;
            }
        },
        async submit() {
            if (this.externalIsEnabled === 1) {
                this.$v.$touch();
            }
            if (this.validate) {
                this.$emit('submit', this);
            }
        }
        ,
        change() {
            if (this.$store.state.emergency.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            }
        }
        ,
        dataChanged() {
            let changed = false;
            if (this.externalIsEnabled !== this.selectedSite.ExternalIsEnabled ||
                this.externalIp !== this.selectedSite.ExternalIp ||
                this.externalMask !== this.selectedSite.ExternalMask ||
                this.externalCode !== this.selectedSite.ExternalCode
            ) {
                changed = true;
            }
            return changed;
        }
        ,
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                ExternalIsEnabled: this.externalIsEnabled,
                ExternalCode: this.externalCode,
                ExternalIp: this.externalIp,
                ExternalMask: this.externalMask,
            }
        }
        ,
        updateExternalIsEnabled() {
            this.$store.commit('emergency/updateExternalIsEnabled', this.externalIsEnabled)
        }
    },
    watch: {
        selectedSite() {
            this.init();
        },
        updated() {
            this.init();
        },
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        }
    }
}
</script>

<style scoped>

</style>